import { apiClient } from './api';
import { ApiResponse, OpportunityBatch, Opportunity } from '../types';

export const batchesService = {
  /**
   * Get all reconciliation batches
   */
  async getBatches() {
    const response = await apiClient.get<ApiResponse<OpportunityBatch[]>>('/api/batches');
    return response.data;
  },

  /**
   * Get opportunities for a specific batch
   */
  async getOpportunitiesByBatch(batchName: string) {
    const response = await apiClient.get<ApiResponse<Opportunity[]>>(
      `/api/batches/${encodeURIComponent(batchName)}/opportunities`
    );
    return response.data;
  },

  /**
   * Update batch status
   */
  async updateBatchStatus(batchName: string, status: string) {
    const response = await apiClient.patch<ApiResponse<void>>(
      `/api/batches/${encodeURIComponent(batchName)}/status`,
      { status }
    );
    return response.data;
  },
};
